const CDN =
  "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/1de2a639-fd5d-41f9-81c4-60b9a63ce653/";

export const pricing = {
  price: "US$ 14",
  originalPrice: "US$ 69",
  savings: "US$ 55",
};

export const checkoutUrl = "https://equilibrio-60.impultienda.ar/checkout";

export const marqueeItems = [
  "📘 600 fichas ilustradas prontas para imprimir",
  "🔒 Pagamento 100% seguro",
  "🛡️ Garantia de 7 dias",
  "⚡ Acesso imediato",
];

export const heroImage = {
  src: CDN + "1792793971072_eq60-hero.webp",
  alt: "Coleção Equilíbrio 60+ — 5 tomos com 600 fichas de exercícios para idosos",
};

export const offerItems = [
  { name: "Bônus 1: Mobilidade Reduzida (120 fichas)" },
  { name: "Bônus 2: Recuperação Pós-Queda (60 fichas)" },
  { name: "Bônus 3: Guia de Avaliação de Risco de Queda" },
  { name: "Bônus 4: Montador de Sessões (30+ sessões prontas)" },
];

export const ringImages = [
  { src: CDN + "1792793976340_eq60-ring1.webp", alt: "Ficha de exercício — Equilíbrio 60+" },
  { src: CDN + "1792793977233_eq60-ring2.webp", alt: "Capa do Tomo 1 — Equilíbrio 60+" },
  { src: CDN + "1792793978213_eq60-ring3.webp", alt: "Ficha de exercício — Equilíbrio 60+" },
  { src: CDN + "1792793979084_eq60-ring4.webp", alt: "Ficha de exercício — Equilíbrio 60+" },
  { src: CDN + "1792793980021_eq60-ring5.webp", alt: "Capa do Tomo 3 — Equilíbrio 60+" },
  { src: CDN + "1792793980823_eq60-ring6.webp", alt: "Ficha do Bônus Mobilidade Reduzida" },
  { src: CDN + "1792793981637_eq60-ring7.webp", alt: "Ficha para grupos — Equilíbrio 60+" },
];

export const tomos = [
  {
    number: 1,
    title: "Tomo 1 · Equilíbrio e Prevenção de Quedas",
    count: "150 FICHAS",
    description:
      "Exercícios de equilíbrio estático e dinâmico, transferência de peso, marcha e reações de proteção — o núcleo de qualquer programa para reduzir o risco de queda.",
    tag: "Prevenção de quedas",
    img: CDN + "1792793983436_eq60-tomo1.webp",
    alt: "Tomo 1 — Equilíbrio e prevenção de quedas",
  },
  {
    number: 2,
    title: "Tomo 2 · Força Funcional",
    count: "150 FICHAS",
    description:
      "Fortalecimento de membros inferiores, superiores e core com peso corporal, faixas e objetos simples, para manter a massa muscular e a independência.",
    tag: "Contra a sarcopenia",
    img: CDN + "1792793984396_eq60-tomo2.webp",
    alt: "Tomo 2 — Força funcional",
  },
  {
    number: 3,
    title: "Tomo 3 · Mobilidade e Alongamento",
    count: "100 FICHAS",
    description:
      "Mobilidade articular, alongamentos e respiração para ganhar amplitude, aliviar rigidez e preparar o corpo para o restante da sessão.",
    tag: "Amplitude e relaxamento",
    img: CDN + "1792793985617_eq60-tomo3.webp",
    alt: "Tomo 3 — Mobilidade e alongamento",
  },
  {
    number: 4,
    title: "Tomo 4 · Atividades da Vida Diária",
    count: "100 FICHAS",
    description:
      "Treino funcional das tarefas reais: levantar da cadeira, subir escadas, entrar no carro, sair da cama, carregar compras. Exercícios que viram autonomia.",
    tag: "Autonomia no dia a dia",
    img: CDN + "1792793986845_eq60-tomo4.webp",
    alt: "Tomo 4 — Atividades da vida diária",
  },
  {
    number: 5,
    title: "Tomo 5 · Atividades em Grupo",
    count: "100 FICHAS",
    description:
      "Circuitos, dinâmicas e jogos para turmas, ILPIs e centros de convivência — sessões em grupo seguras, divertidas e fáceis de conduzir.",
    tag: "Para grupos e instituições",
    img: CDN + "1792793987949_eq60-tomo5.webp",
    alt: "Tomo 5 — Atividades em grupo",
  },
];

export const comboItems = [
  {
    label: "COLEÇÃO",
    badge: "INCLUÍDO",
    title: "Coleção Equilíbrio 60+ · 5 tomos",
    description:
      "600 fichas ilustradas, cada uma com objetivo, posição inicial, passo a passo, séries e repetições, cuidados de segurança e variações para facilitar ou progredir.",
    points: ["600 fichas", "622 páginas", "PDF A4"],
    img: CDN + "1792793969912_eq60-colecao.webp",
    alt: "Coleção Equilíbrio 60+",
  },
  {
    label: "BÔNUS 1",
    badge: "GRÁTIS",
    title: "Mobilidade Reduzida",
    description:
      "120 fichas para pacientes em cadeira de rodas, acamados ou com grande limitação: exercícios sentado, no leito e com apoio, para não deixar ninguém de fora.",
    points: ["120 fichas", "Sentado e no leito"],
    img: CDN + "1792793965599_eq60-bonus1.webp",
    alt: "Bônus 1 — Mobilidade Reduzida",
  },
  {
    label: "BÔNUS 2",
    badge: "GRÁTIS",
    title: "Recuperação Pós-Queda",
    description:
      "60 fichas para devolver a confiança a quem já caiu: como levantar do chão, perder o medo de se mover e retomar a rotina com segurança.",
    points: ["60 fichas", "Medo de cair"],
    img: CDN + "1792793966679_eq60-bonus2.webp",
    alt: "Bônus 2 — Recuperação Pós-Queda",
  },
  {
    label: "BÔNUS 3",
    badge: "GRÁTIS",
    title: "Guia de Avaliação de Risco de Queda",
    description:
      "Testes funcionais explicados passo a passo, com fichas de registro prontas para avaliar, documentar a evolução e escolher o tomo certo para cada paciente.",
    points: ["Testes funcionais", "Fichas de registro"],
    img: CDN + "1792793967657_eq60-bonus3.webp",
    alt: "Bônus 3 — Guia de Avaliação de Risco de Queda",
  },
  {
    label: "BÔNUS 4",
    badge: "GRÁTIS",
    title: "Montador de Sessões · 30+ sessões prontas",
    description:
      "Sessões completas já montadas com as fichas da coleção — aquecimento, parte principal e volta à calma — por objetivo e por nível. É só escolher e aplicar.",
    points: ["30+ sessões", "Por nível"],
    img: CDN + "1792793968665_eq60-bonus4.webp",
    alt: "Bônus 4 — Montador de Sessões",
  },
];

export const benefits = [
  { icon: "⏱️", title: "Planejamento em minutos", text: "Escolha as fichas pelo objetivo e monte a sessão inteira sem começar do zero." },
  { icon: "🛡️", title: "Segurança em cada exercício", text: "Cada ficha traz cuidados, contraindicações e a forma correta de apoio e supervisão." },
  { icon: "📈", title: "Progressão e regressão", text: "Variações para facilitar ou desafiar, para adaptar o mesmo exercício a cada paciente." },
  { icon: "🖨️", title: "Pronto para imprimir em A4", text: "Tamanho certo para imprimir, entregar ao paciente ou ao cuidador e usar como guia em casa." },
  { icon: "🪑", title: "Materiais simples e caseiros", text: "Cadeira, parede, toalha, garrafa d'água e faixa elástica. Nada de equipamento caro." },
  { icon: "👥", title: "Do individual ao grupo", text: "Funciona no atendimento um a um e também em turmas, ILPIs e centros de convivência." },
];

export const audience = [
  { icon: "🩺", title: "Fisioterapeutas", text: "Em consultório, home care ou clínica, com fichas que você entrega e o paciente entende." },
  { icon: "🏃", title: "Educadores físicos", text: "Para turmas da terceira idade, treino funcional e programas de prevenção de quedas." },
  { icon: "🧩", title: "Terapeutas ocupacionais", text: "Com foco nas atividades da vida diária e na independência funcional." },
  { icon: "🏠", title: "Cuidadores e instituições", text: "ILPIs, casas de repouso e centros-dia que precisam de atividades seguras e organizadas." },
];

export const testimonials = [
  {
    pain: "01 · Falta de tempo",
    title: "Consigo organizar minhas sessões com muito mais facilidade",
    quote:
      "Minha maior dificuldade era selecionar exercícios e organizar cada sessão de acordo com as necessidades do paciente. A proposta das fichas organizadas por categorias e níveis pode facilitar bastante esse processo e ajudar a manter uma rotina de atendimento mais estruturada.",
    name: "Camila Ferreira",
    role: "Fisioterapeuta · Brasil",
  },
  {
    pain: "02 · Pacientes com diferentes capacidades",
    title: "Uma proposta para diferentes níveis de mobilidade",
    quote:
      "O que me chamou a atenção foi a divisão dos exercícios em níveis iniciante, intermediário e avançado. Essa organização pode ajudar no planejamento, desde que a escolha dos exercícios seja feita conforme a avaliação individual de cada paciente.",
    name: "Rafael Moreira",
    role: "Educador físico · Brasil",
  },
  {
    pain: "03 · Dificuldade para escolher exercícios",
    title: "Mais opções para trabalhar equilíbrio e marcha",
    quote:
      "Ter um material organizado especificamente para equilíbrio, marcha e transferências pode ser útil para consultar diferentes possibilidades de exercícios e preparar atendimentos mais direcionados aos objetivos funcionais de cada pessoa.",
    name: "Inês Carvalho",
    role: "Fisioterapeuta · Portugal",
  },
];

export const paymentMethods = [
  { src: CDN + "1792793972443_eq60-pay-applepay.webp", alt: "Apple Pay" },
  { src: CDN + "1792793974658_eq60-pay-mastercard.webp", alt: "Mastercard" },
  { src: CDN + "1792793975494_eq60-pay-visa.webp", alt: "Visa" },
  { src: CDN + "1792793973832_eq60-pay-gpay.webp", alt: "Google Pay" },
];

export const faqs = [
  { q: "Como recebo a coleção?", a: "Logo após a confirmação do pagamento, você recebe no seu e-mail o acesso para baixar os 5 tomos e os 4 bônus. A entrega é automática e imediata." },
  { q: "É um produto físico ou digital?", a: "É 100% digital, em PDF. Você pode ler no celular, tablet ou computador e imprimir quantas vezes quiser, em tamanho A4." },
  { q: "Serve para atendimento domiciliar, clínica e instituições?", a: "Sim. As fichas foram pensadas para consultório, home care, ILPIs, casas de repouso e grupos de terceira idade." },
  { q: "Funciona para pacientes com níveis diferentes?", a: "Sim. Os exercícios trazem variações para facilitar ou progredir, e o Bônus 1 é inteiro dedicado a quem tem mobilidade reduzida ou está acamado." },
  { q: "Preciso de equipamentos?", a: "Não. A grande maioria dos exercícios usa só o corpo, uma cadeira, a parede ou objetos simples de casa. Alguns usam faixa elástica, sempre opcional." },
  { q: "Por quanto tempo terei acesso?", a: "O acesso é vitalício. Você baixa os arquivos e eles ficam com você para sempre, sem mensalidade." },
  { q: "O material está em português?", a: "Sim, todo o conteúdo está em português do Brasil, com linguagem clara para o profissional e para o paciente." },
  { q: "E se eu não gostar?", a: "Você tem 7 dias de garantia. Se a coleção não for para você, é só pedir o reembolso dentro desse prazo." },
  { q: "As fichas substituem a avaliação profissional?", a: "Não. A coleção é um material de apoio para profissionais. A escolha dos exercícios deve sempre partir da avaliação individual de cada paciente." },
];

export const floatingThumb = {
  src: CDN + "1792793982418_eq60-thumb.webp",
  alt: "Equilíbrio 60+",
};
